import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

const CYRILLIC_FIO_CHARS = /^[-`''’А-Яа-яЁёËЎўІі]*$/u;
const CYRILLIC_FIO_EDGES = /^[А-Яа-яЁёËЎўІі](.*[А-Яа-яЁёËЎўІі])?$/u;

/**
 * @description Проверяет значение по правилам кириллического ФИО.
 * Возвращает собственные ключи ошибок, чтобы сообщения отличались от общего pattern.
 */
function cyrillicFio(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (!CYRILLIC_FIO_CHARS.test(value)) {
      return { cyrillicFio: true };
    }

    if (!CYRILLIC_FIO_EDGES.test(value)) {
      return { cyrillicFioEdges: true };
    }

    return null;
  };
}

export class FioValidators {
  public static firstName(): ValidatorFn {
    return Validators.compose([
      Validators.pattern(
        "^(([a-zA-Z''`‘’`‘’`'`-]+)|([а-яА-ЯёўіЁЎІ''`‘’`‘’`'`-]+))$"
      ),
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(30),
    ]);
  }
  public static secondName(): ValidatorFn {
    return Validators.compose([
      Validators.pattern(
        "^(([a-zA-Z''`‘’`‘’`'`-]+)|([а-яА-ЯёўіЁЎІ''`‘’`‘’`'`-]+))$"
      ),
      Validators.minLength(2),
      Validators.maxLength(30),
    ]);
  }
  public static lastName(): ValidatorFn {
    return Validators.compose([
      Validators.pattern(
        "^(([a-zA-Z''`‘’`‘’`'`-]+)|([а-яА-ЯёўіЁЎІ''`‘’`‘’`'`-]+))$"
      ),
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(50),
    ]);
  }
  /**
   * @description Имя: только кириллица, обязательно. Для форм с серверной
   * проверкой кириллицы (идентификация).
   */
  public static cyrillicFirstName(): ValidatorFn {
    return Validators.compose([
      cyrillicFio(),
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(30),
    ]);
  }

  /**
   * @description Отчество: только кириллица.
   */
  public static cyrillicSecondName(): ValidatorFn {
    return Validators.compose([
      cyrillicFio(),
      Validators.minLength(2),
      Validators.maxLength(30),
    ]);
  }

  /**
   * @description Фамилия: только кириллица, обязательно.
   */
  public static cyrillicLastName(): ValidatorFn {
    return Validators.compose([
      cyrillicFio(),
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(50),
    ]);
  }

  public static fullName(checkLength = false, courrier = false): ValidatorFn {
    return (form: FormGroup) => {
      const pattern =
        /^(([a-zA-Z''`‘’`‘’`'`-]+)|([а-яА-ЯёўіЁЎІ''`‘’`‘’`'`-]+))$/;

      const firstName = form.get('first_name').value;
      const lastName = form.get('last_name').value;
      const secondName =
        (courrier
          ? form.get('patronym').value
          : form.get('second_name').value) || '';

      if (!firstName || !lastName) {
        return null;
      }

      if (
        checkLength &&
        firstName.length + secondName.length + lastName.length > 50
      ) {
        return { fullNameLength: true };
      }
      if (!pattern.test(firstName.concat(secondName).concat(lastName))) {
        return { fullNameSymbol: true };
      }
    };
  }
}
